import React from 'react';

/**
 * ReasonField Component
 * Renders a text input for the reason with validation feedback.
 * Props:
 *  - state: form state object
 *  - handleChange: input change handler
 */
const ReasonField = ({ state, handleChange }) => {
  return (
    <div className="row mt-3">
      <div className="col-12">
        {/* Form group for the reason input with floating label and validation */}
        <div className="form-floating mb-4 position-relative">
          <input
            type="text"
            id="reason"
            name="reason"
            value={state.reason}
            onChange={handleChange}
            placeholder=" "
            autoComplete='off'
            // Apply validation classes based on error presence or value existence
            className={`form-control ${
              state.errors.reason ? 'is-invalid' : state.reason ? 'is-valid' : ''
            }`}
          />
          <label htmlFor="reason">Reason</label>

          {/* Display error tooltip if there is a validation error */}
          {state.errors.reason && (
            <div className="invalid-tooltip">{state.errors.reason}</div>
          )}

          {/* Display success tooltip if input is valid */}
          {state.reason && !state.errors.reason && (
            <div className="valid-tooltip">Reason provided</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReasonField;
